import React, { lazy, Suspense, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
const AddOrganizations = lazy(() =>
  import("src/features/Modal").then((modal) => ({
    default: modal.AddOrganizations,
  }))
);

export default function AddNomenclatureButton() {
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      <Button
        style={{ marginBottom: 15 }}
        icon={<PlusOutlined />}
        type="primary"
        onClick={() => setOpen(true)}
      >
        Добавить организацию
      </Button>
      {isOpen ? (
        <Suspense fallback={<div></div>}>
          <AddOrganizations isOpen={isOpen} setOpen={setOpen} />
        </Suspense>
      ) : null}
    </>
  );
}
